import { createContext, useContext } from 'react';
import {
    HomeFocusSelection,
    HomeFocusSelectionType
} from '../../stores/HomeStore';

interface HomeContext {
    focus: HomeFocusSelectionType;
    setFocus: (focus: HomeFocusSelectionType) => void;
}

export const HomeContext = createContext<HomeContext>({
    focus: HomeFocusSelection.terminal,
    setFocus: () => null
});

export const useHomeContext = () => useContext(HomeContext);

export const { Provider: HomeContextProvider } = HomeContext;
